import Config from '@config';
import { createApi } from '@reduxjs/toolkit/query/react';

import { GetMeteringPointsParams, MeteringPoint } from '@/features/meteringPoints/types';
import axiosBaseQuery from '@/utils/axiosBaseQuery';

export const meteringPointsApi = createApi({
  reducerPath: 'meteringPointsApi',
  baseQuery: axiosBaseQuery({
    baseUrl: Config.VITE_API_URL + '/metering-points',
  }),
  tagTypes: ['MeteringPoint'],
  endpoints: builder => ({
    getMeteringPoints: builder.query<MeteringPoint[], GetMeteringPointsParams>({
      query: params => ({
        url: '',
        params,
      }),
      providesTags: ['MeteringPoint'],
    }),
  }),
});

export const { useGetMeteringPointsQuery } = meteringPointsApi;
